// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import './util/rem.js';
import axios from 'axios'
// import 'lib-flexible'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import {
  host
} from './axios/config.js';
import api from './axios/api.js';
import Head from './components/header.vue'
Vue.use(ElementUI);
import App from './App'
import router from './router'
Vue.prototype.$host = host
Vue.prototype.$api = api
Vue.prototype.$axios = axios
Vue.config.productionTip = false
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    "inline": true,
    "button": true,
    "navbar": true,
    "title": true,
    "toolbar": true,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
    "url": "data-source"
  }
});

/* eslint-disable no-new */
Vue.component('Head', Head)
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js